import { createSelector } from 'reselect'

import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import originRouteTypes from 'helpers/enums/store/originRouteTypes'

const getUser = state => state.user
const getUI = state => state.ui

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.STORE_NEW_ROUTES,
])

const storeNewRouteRedirection = createSelector(
	[ getUI, getUser, featureFlagsSelector ],
	(ui, user, featureFlags) => {
		const FFReadyForUse = user.featureFlagsHash !== 0
		const storeRouteOrigin = ui.storeRouteOrigin
		const shouldSeeNewRoute = featureFlags[featureFlagsTypes.STORE_NEW_ROUTES]
		let from, to
		let shouldRedirect = false

		if (FFReadyForUse && !!storeRouteOrigin) {
			if (storeRouteOrigin === originRouteTypes.OLD_STORE && shouldSeeNewRoute) {
				shouldRedirect = true
				from = '/t/'
				to = '/s/'
			} else if (storeRouteOrigin === originRouteTypes.NEW_STORE && !shouldSeeNewRoute) {
				shouldRedirect = true
				from = '/s/'
				to = '/t/'
			}
		}

		return {
			from,
			to,
			shouldRedirect,
		}
	}
)

export default storeNewRouteRedirection
